export default __webpack_public_path__ + "static/media/1.f74f0939.svg";